// окно добавления журнала угловых измерений станции
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CButton,
    CFormInput,
    CFormSelect,
    CTable,
    CTableHead,
    CTableRow,
    CTableHeaderCell,
    CTableBody,
    CTableDataCell,
} from '@coreui/react';

const token = localStorage.getItem("token");

const AddMeasurementModal = ({ visible, onClose, protocolId }) => {
    // Логируем получение protocolId
    useEffect(() => {
        console.log("AddMeasurementModal получил protocolId:", protocolId);
        if (!protocolId) {
            console.warn("Предупреждение: protocolId не передан или равен null");
        }
    }, [protocolId]);

    // Состояния формы
    const [setMarksModalVisible, setSetMarksModalVisible] = useState(false);
    const [marksCount, setMarksCount] = useState('');
    const [distanceDiag, setDistanceDiag] = useState('');
    const [distanceBelt, setDistanceBelt] = useState('');
    const [cloudiness, setCloudiness] = useState('');
    const [windSpeed, setWindSpeed] = useState('');
    const [xFormula, setXFormula] = useState('ОТКЛ');
    const [yFormula, setYFormula] = useState('0');


    // Таблица данных (не влияет на сохранение, но может быть расширена)
    const [tableData, setTableData] = useState([
        {
            id: 1,
            mark: '',
            kr_deg_measured: '',
            kr_min_measured: '',
            kr_sec_measured: '',
            kl_deg_measured: '',
            kl_min_measured: '',
            kl_sec_measured: '',
            error_fact_measured: '',
            error_corr_measured: '',
        },
    ]);

    // Обработчик сохранения Station и Source
    const handleSave = () => {
        if (!protocolId) {
            alert("Не указан ID протокола");
            return;
        }

        const formData = {
            idProtocol: protocolId,
            StationNum: 1,
            DistanceBelt: distanceBelt || null,
            DistanceDiag: distanceDiag || null,
            Wind: windSpeed || null,
            Cloud: cloudiness || null,
            XVal: xFormula,
            YVal: yFormula,
            DressPoint: '',
            idParent: null,
            IsRotate: false
        };

        console.log('FormData перед отправкой:', formData);

        axios.post('/api/protocols/station/', formData, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                const newStationId = parseInt(response.data.id, 10);
                console.log('Станция сохранена с ID:', newStationId);

                const promises = tableData.flatMap((row, index) => {
                    if (!row.mark ||
                        !row.kr_deg_measured || !row.kr_min_measured || !row.kr_sec_measured ||
                        !row.kl_deg_measured || !row.kl_min_measured || !row.kl_sec_measured) {
                        console.warn("Пропущены данные для строки", row);
                        return [];
                    }

                    const pointNum = index + 1; 
                    const pointMark = parseFloat(row.mark) || 0.0; 

                    const kr_grad = parseInt(row.kr_deg_measured) || 0;
                    const kr_min = parseInt(row.kr_min_measured) || 0;
                    const kr_sec = parseInt(row.kr_sec_measured) || 0;
                    const kl_grad = parseInt(row.kl_deg_measured) || 0;
                    const kl_min = parseInt(row.kl_min_measured) || 0;
                    const kl_sec = parseInt(row.kl_sec_measured) || 0;

                    // Первая запись
                    const sourceData1 = {
                        PointNum: pointNum,
                        PointMark: pointMark,
                        KrGrad: kr_grad,
                        KrMin: kr_min,
                        KrSec: kr_sec,
                        KlGrad: kl_grad,
                        KlMin: kl_min,
                        KlSec: kl_sec,
                        SubStation: 1,
                        idStation: newStationId,
                    };

                    // Вторая запись
                    const sourceData2 = {
                        PointNum: pointNum,
                        PointMark: pointMark,
                        KrGrad: kl_grad,
                        KrMin: kl_min,
                        KrSec: kl_sec,
                        KlGrad: kr_grad,
                        KlMin: kr_min,
                        KlSec: kr_sec,
                        SubStation: 1,
                        idStation: newStationId,
                    };

                    console.log('Отправляем в sourceData1:', sourceData1);
                    for (const [key, val] of Object.entries(sourceData1)) {
                        console.log(`${key} (${typeof val}):`, val);
                    }

                    return [
                        axios.post('/api/protocols/source/', sourceData1, {
                            headers: { Authorization: `Bearer ${token}` },
                        }),
                        axios.post('/api/protocols/source/', sourceData2, {
                            headers: { Authorization: `Bearer ${token}` },
                        }),
                    ];
                });

                Promise.all(promises)
                    .then(responses => {
                        console.log('Все записи в source добавлены:', responses.map(r => r.data));
                        alert("Станция и записи успешно добавлены");
                        onClose();
                    })
                    .catch(error => {
                        console.error("Ошибка при добавлении записей в source:", error.response?.data || error.message);
                        alert("Ошибка при добавлении записей в source");
                    });
            })
            .catch((error) => {
                console.error("Ошибка при добавлении станции:", error);
                alert("Ошибка при добавлении станции");
            });
    };

    // Опции для Y в зависимости от X
    const getYOptions = () => {
        switch (xFormula) {
            case 'ОТКЛ':
            case '-ОТКЛ':
                return ['0'];
            case '0':
                return ['ОТКЛ', '-ОТКЛ'];
            case 'SIN':
            case '-SIN':
                return ['COS', '-COS'];
            case 'COS':
            case '-COS':
                return ['SIN', '-SIN'];
            default:
                return ['0'];
        }
    };

    // Обновление Y при изменении X
    useEffect(() => {
        const yOptions = getYOptions();
        if (!yOptions.includes(yFormula)) {
            setYFormula(yOptions[0]);
        }
    }, [xFormula]);

    // Добавление строки в таблицу
    const addTableRow = () => {
        const newRow = {
            id: tableData.length + 1,
            mark: '',
            kr_deg_measured: '',
            kr_min_measured: '',
            kr_sec_measured: '',
            kl_deg_measured: '',
            kl_min_measured: '',
            kl_sec_measured: '',
            error_fact_measured: '',
            error_corr_measured: '',

        };
        setTableData([...tableData, newRow]);
    };

    // Удаление строки из таблицы
    const removeTableRow = (id) => {
        setTableData(tableData.filter(row => row.id !== id));
    };

    const SetMarksModal = () => (
        <CModal visible={setMarksModalVisible} onClose={() => setSetMarksModalVisible(false)}>
            <CModalHeader>
                <CModalTitle>Укажите количество отметок</CModalTitle>
            </CModalHeader>
            <CModalBody>
                <div className="mb-3">
                    <label className="form-label">Количество отметок</label>
                    <CFormInput
                        type="number"
                        min="1"
                        value={marksCount}
                        onChange={(e) => setMarksCount(e.target.value)}
                        placeholder="Введите число"
                    />
                </div>
                <div className="d-flex justify-content-end gap-2">
                    <CButton color="secondary" onClick={() => setSetMarksModalVisible(false)}>Отменить</CButton>
                    <CButton color="primary" onClick={() => {
                        const count = parseInt(marksCount, 10);
                        if (!isNaN(count) && count > 0) {
                            const newTableData = Array.from({ length: count }, (_, index) => ({
                                id: index + 1,
                                mark: '',
                                kr_deg: '',
                                kr_min: '',
                                kr_sec: '',
                                kl_deg: '',
                                kl_min: '',
                                kl_sec: '',
                                error_fact: '',
                                error_corr: ''
                            }));
                            setTableData(newTableData);
                        }
                        setSetMarksModalVisible(false);
                    }}>ОК</CButton>
                </div>
            </CModalBody>
        </CModal>
    );

    return (
        <CModal visible={visible} onClose={onClose} size="xl">
            <CModalHeader>
                <CModalTitle>Добавить измерение</CModalTitle>
            </CModalHeader>
            <CModalBody>
                <div className="mb-3 d-flex gap-2">
                    <CButton color="secondary">Просмотр</CButton>
                    <CButton color="secondary" onClick={() => {
                        setMarksCount(tableData.length.toString());
                        setSetMarksModalVisible(true);
                    }}>Задать количество отметок</CButton>
                    <CButton color="secondary">Привести погрешность</CButton>
                    <CButton color="success" onClick={() => {
                        console.log("Клик по кнопке 'Сохранить'");
                        handleSave();
                    }}>    Сохранить
                    </CButton>
                    <CButton color="danger" onClick={onClose}>Отмена</CButton>
                </div>

                {/* Форма ввода */}
                <div className="row mb-3">
                    <div className="col-md-6">
                        <div className="d-flex align-items-center mb-2">
                            <label className="form-label w-50 text-end pe-3 mb-0">Расстояние от стоянки до оси</label>
                            <CFormInput
                                type="number"
                                className="w-50"
                                value={distanceDiag}
                                onChange={(e) => setDistanceDiag(e.target.value)}
                            />
                        </div>
                        <div className="d-flex align-items-center">
                            <label className="form-label w-50 text-end pe-3 mb-0">Расстояние до стоянки</label>
                            <CFormInput
                                type="number"
                                className="w-50"
                                value={distanceBelt}
                                onChange={(e) => setDistanceBelt(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex align-items-center mb-2">
                            <label className="form-label w-50 text-end pe-3 mb-0">Облачность, %</label>
                            <CFormInput
                                type="number"
                                className="w-50"
                                value={cloudiness}
                                onChange={(e) => setCloudiness(e.target.value)}
                            />
                        </div>
                        <div className="d-flex align-items-center">
                            <label className="form-label w-50 text-end pe-3 mb-0">Ветер м/с</label>
                            <CFormInput
                                type="number"
                                className="w-50"
                                value={windSpeed}
                                onChange={(e) => setWindSpeed(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                {/* Формула */}
                <div className="mb-3">
                    <h6>Формула для схемы расположения стоянки</h6>
                    <div className="d-flex gap-5">
                        <div className="d-flex align-items-center gap-3">
                            <label className="form-label mb-0">X =</label>
                            <CFormSelect
                                value={xFormula}
                                onChange={(e) => setXFormula(e.target.value)}
                                style={{ width: '150px' }}
                            >
                                <option>ОТКЛ</option>
                                <option>-ОТКЛ</option>
                                <option>0</option>
                                <option>SIN</option>
                                <option>-SIN</option>
                                <option>COS</option>
                                <option>-COS</option>
                            </CFormSelect>
                        </div>
                        <div className="d-flex align-items-center gap-3">
                            <label className="form-label mb-0">Y =</label>
                            <CFormSelect
                                value={yFormula}
                                onChange={(e) => setYFormula(e.target.value)}
                                style={{ width: '150px' }}
                            >
                                {getYOptions().map((option, index) => (
                                    <option key={index} value={option}>{option}</option>
                                ))}
                            </CFormSelect>
                        </div>
                    </div>
                </div>

                {/* Таблица */}
                <CTable bordered>
                    <CTableHead>
                        <CTableRow>
                            {/* Основные заголовки с подзаголовками */}
                            <CTableHeaderCell colSpan={2}>Отметка</CTableHeaderCell>
                            <CTableHeaderCell colSpan={3}>KR</CTableHeaderCell>
                            <CTableHeaderCell colSpan={3}>KL</CTableHeaderCell>
                            <CTableHeaderCell colSpan={2}>Погрешность</CTableHeaderCell>
                            <CTableHeaderCell rowSpan={2}>Действия</CTableHeaderCell>
                        </CTableRow>
                        <CTableRow>
                            {/* Подзаголовки Отметка */}
                            <CTableHeaderCell>№ п/п</CTableHeaderCell>
                            <CTableHeaderCell>м</CTableHeaderCell>

                            {/* Подзаголовки KR */}
                            <CTableHeaderCell>град.</CTableHeaderCell>
                            <CTableHeaderCell>мин.</CTableHeaderCell>
                            <CTableHeaderCell>сек.</CTableHeaderCell>

                            {/* Подзаголовки KL */}
                            <CTableHeaderCell>град.</CTableHeaderCell>
                            <CTableHeaderCell>мин.</CTableHeaderCell>
                            <CTableHeaderCell>сек.</CTableHeaderCell>

                            {/* Погрешность */}
                            <CTableHeaderCell>Факт.</CTableHeaderCell>
                            <CTableHeaderCell>Испр.</CTableHeaderCell>
                        </CTableRow>
                    </CTableHead>

                    <CTableBody>
                        {tableData.map((row, index) => (
                            <CTableRow key={row.id}>
                                {/* № п/п */}
                                <CTableDataCell>{index + 1}</CTableDataCell>

                                {/* Отметка */}
                                <CTableDataCell>
                                    <CFormInput size="sm" value={row.mark} onChange={(e) => {
                                        const updated = [...tableData];
                                        updated[index].mark = e.target.value;
                                        setTableData(updated);
                                    }} />
                                </CTableDataCell>

                                {/* KR град. */}
                                <CTableDataCell>
                                    <div className="d-flex flex-column gap-1">
                                        <CFormInput size="sm" value={row.kr_deg_measured} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].kr_deg_measured = e.target.value;
                                            setTableData(updated);
                                        }} />
                                        <CFormInput size="sm" value={row.kr_deg_corrected} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].kr_deg_corrected = e.target.value;
                                            setTableData(updated);
                                        }} />
                                    </div>
                                </CTableDataCell>

                                {/* KR мин. */}
                                <CTableDataCell>
                                    <div className="d-flex flex-column gap-1">
                                        <CFormInput size="sm" value={row.kr_min_measured} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].kr_min_measured = e.target.value;
                                            setTableData(updated);
                                        }} />
                                        <CFormInput size="sm" value={row.kr_min_corrected} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].kr_min_corrected = e.target.value;
                                            setTableData(updated);
                                        }} />
                                    </div>
                                </CTableDataCell>

                                {/* KR сек. */}
                                <CTableDataCell>
                                    <div className="d-flex flex-column gap-1">
                                        <CFormInput size="sm" value={row.kr_sec_measured} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].kr_sec_measured = e.target.value;
                                            setTableData(updated);
                                        }} />
                                        <CFormInput size="sm" value={row.kr_sec_corrected} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].kr_sec_corrected = e.target.value;
                                            setTableData(updated);
                                        }} />
                                    </div>
                                </CTableDataCell>

                                {/* KL град. */}
                                <CTableDataCell>
                                    <div className="d-flex flex-column gap-1">
                                        <CFormInput size="sm" value={row.kl_deg_measured} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].kl_deg_measured = e.target.value;
                                            setTableData(updated);
                                        }} />
                                        <CFormInput size="sm" value={row.kl_deg_corrected} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].kl_deg_corrected = e.target.value;
                                            setTableData(updated);
                                        }} />
                                    </div>
                                </CTableDataCell>

                                {/* KL мин. */}
                                <CTableDataCell>
                                    <div className="d-flex flex-column gap-1">
                                        <CFormInput size="sm" value={row.kl_min_measured} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].kl_min_measured = e.target.value;
                                            setTableData(updated);
                                        }} />
                                        <CFormInput size="sm" value={row.kl_min_corrected} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].kl_min_corrected = e.target.value;
                                            setTableData(updated);
                                        }} />
                                    </div>
                                </CTableDataCell>

                                {/* KL сек. */}
                                <CTableDataCell>
                                    <div className="d-flex flex-column gap-1">
                                        <CFormInput size="sm" value={row.kl_sec_measured} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].kl_sec_measured = e.target.value;
                                            setTableData(updated);
                                        }} />
                                        <CFormInput size="sm" value={row.kl_sec_corrected} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].kl_sec_corrected = e.target.value;
                                            setTableData(updated);
                                        }} />
                                    </div>
                                </CTableDataCell>

                                {/* Погрешность Факт. изм */}
                                <CTableDataCell>
                                    <div className="d-flex flex-column gap-1">
                                        <CFormInput size="sm" value={row.error_fact_measured} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].error_fact_measured = e.target.value;
                                            setTableData(updated);
                                        }} />
                                        <CFormInput size="sm" value={row.error_fact_corrected} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].error_fact_corrected = e.target.value;
                                            setTableData(updated);
                                        }} />
                                    </div>
                                </CTableDataCell>

                                {/* Погрешность Факт. испр */}
                                <CTableDataCell>
                                    <div className="d-flex flex-column gap-1">
                                        <CFormInput size="sm" value={row.error_corr_measured} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].error_corr_measured = e.target.value;
                                            setTableData(updated);
                                        }} />
                                        <CFormInput size="sm" value={row.error_corr_corrected} onChange={(e) => {
                                            const updated = [...tableData];
                                            updated[index].error_corr_corrected = e.target.value;
                                            setTableData(updated);
                                        }} />
                                    </div>
                                </CTableDataCell>

                                {/* Действия */}
                                <CTableDataCell>
                                    <CButton color="danger" size="sm" onClick={() => removeTableRow(row.id)}>Удалить</CButton>
                                </CTableDataCell>

                            </CTableRow>
                        ))}
                    </CTableBody>

                </CTable>
                <CButton color="primary" onClick={addTableRow} className="mt-2">Добавить строку</CButton>
            </CModalBody>
            <SetMarksModal />
        </CModal>
    );
};

export default AddMeasurementModal;